import { addProtocol } from '../../../../../utils/addProtocol';
import { useTranslation } from '../../../../../utils/useTranslation';
import { IconCalendar } from '../../../../icon/IconCalendar';
import { Button } from '../../../../input/Button';
import { BookingButtonProps } from './types';

export const BookingButton = ({ url, onClick, text, ...other }: BookingButtonProps) => {
    const t = useTranslation();

    return (
        <Button
            flexGrow={1}
            as="a"
            href={addProtocol(url)}
            target="_blank"
            size="m"
            rel="nofollow noreferrer"
            variant="filled"
            color="secondary"
            spacing={1}
            onClick={onClick}
            {...other}
        >
            <IconCalendar fontSize={20} color="inherit" />
            {text ?? t('Записаться')}
        </Button>
    );
};
